// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__7NAbR","colMaxWidth":"Table_colMaxWidth__361k1"};